'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _makeCustomProvider = require('../../utils/reactRedux/makeCustomProvider');

var _makeCustomProvider2 = _interopRequireDefault(_makeCustomProvider);

var _measurementsConstants = require('./measurementsConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
exports.default = (0, _makeCustomProvider2.default)(_measurementsConstants.MEASUREMENTS_STORE_NAME);

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/MeasurementsProvider.js
// module id = 1907
// module chunks = 0